// Generated by genversion.
export const version = '2.57.0';
//# sourceMappingURL=version.js.map